import { type FC } from 'react';

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { LuHelpCircle } from 'react-icons/lu';

import { CircularIconContainer } from '../Icons';

export type DeleteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subTitle: string;
  onDelete: () => Promise<void>;
  isLoading: boolean;
};

export const DeleteModal: FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  title,
  subTitle,
  onDelete,
  isLoading,
}) => {
  const { t } = useTranslation(['common']);

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader justifyItems="center">
          <CircularIconContainer icon={LuHelpCircle} gradientColor="error" />
        </ModalHeader>
        <ModalBody>
          <VStack gap={2}>
            <VStack gap={1}>
              <Text fontWeight="semibold" fontSize="xl" textAlign="center">
                {title}
              </Text>

              <Text color="gray.600" fontSize="sm" textAlign="center" mt={2}>
                {subTitle}
              </Text>
            </VStack>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <HStack gap={3} w="full">
            <Button onClick={onClose} flexGrow={1} color="brand.500">
              {t('actions.cancel2')}
            </Button>
            <Button
              isLoading={isLoading}
              flexGrow={1}
              variant="@primary"
              onClick={async () => {
                await onDelete();
                onClose();
              }}
            >
              {t('actions.yes_delete')}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
